import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../Button";

import style from "./styles.module.scss";

const keyI18n = "translations.whoswho.prosecutors";

export type ProsecutorRole = "general" | "deputy";

export interface ProsecutorProps {
  name: string;
  image: string;
  positionKey: string;
  bioKey: string;
  role: ProsecutorRole;
  collapsible: boolean;
}

export default function Prosecutor({
  name,
  image,
  positionKey,
  bioKey,
  role,
  collapsible,
}: ProsecutorProps) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(!collapsible);

  const positionClass =
    role === "general" ? style.positionGeneral : style.positionDeputy;

  return (
    <article className={style.prosecutor}>
      <img
        alt={t(`${keyI18n}.imageAlt`, { name })}
        className={style.image}
        decoding="async"
        height={156}
        src={image}
        width={156}
      />

      <div className={style.about}>
        <span className={`pgm-label-medium ${style.position} ${positionClass}`}>
          {t(positionKey)}
        </span>

        <div className={style.infos}>
          <h3 className={`pgm-title-medium ${style.name}`}>{name}</h3>
          <p
            className={[
              "pgm-body-large",
              style.bio,
              expanded ? "" : style.bioCollapsed,
            ]
              .filter(Boolean)
              .join(" ")}
          >
            {t(bioKey)}
          </p>

          {collapsible && (
            <Button
              aria-expanded={expanded}
              className={style.toggle}
              icon={
                <span className="material-symbols-sharp">
                  {expanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
              }
              onClick={() => setExpanded(!expanded)}
              variant="text"
            >
              {t(expanded ? `${keyI18n}.seeLess` : `${keyI18n}.seeMore`)}
            </Button>
          )}
        </div>
      </div>
    </article>
  );
}
